// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

import { colors } from "../../../utils/theme/colors"
import { fontWeights } from "../../../utils/theme/font-weights"
import Paragraph from "./paragraph"

const Address = ({ title, paragraph1, paragraph2 }) => {
  const data = useStaticQuery(graphql`
    query AddressQuery {
      phone: file(relativePath: { eq: "phone.png" }) {
        childImageSharp {
          fixed(width: 14, height: 15) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      address: file(relativePath: { eq: "adress.png" }) {
        childImageSharp {
          fixed(width: 12, height: 15) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)
  const address = data.address.childImageSharp.fixed
  const phone = data.phone.childImageSharp.fixed
  return (
    <div
      sx={{
        marginTop: [`2.5rem`, null, 0, null],
      }}
    >
      <p
        sx={{
          color: colors.white,
          fontWeight: fontWeights.black,
          fontSize: `1.13rem`,
          lineHeight: 1.11,
          marginTop: 0,
        }}
      >
        {title}
      </p>
      <div
        sx={{
          display: `flex`,
          flexDirection: `column`,
          marginBottom: `1rem`,
        }}
      >
        <div sx={{ display: `flex`, alignItems: `center` }}>
          <div sx={{ marginRight: `1rem` }}>
            <Img alt="" fixed={address} />
          </div>
          <div>
            <Paragraph>{paragraph1}</Paragraph>
          </div>
        </div>
        <div sx={{ display: `flex`, alignItems: `center` }}>
          <div sx={{ marginRight: `1rem` }}>
            <Img alt="" fixed={phone} />
          </div>
          <div>
            <Paragraph>{paragraph2}</Paragraph>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Address
